import {provideHttpClient, withFetch, withInterceptors} from '@angular/common/http';
import {ApplicationConfig, provideBrowserGlobalErrorListeners} from '@angular/core';
import {provideRouter} from '@angular/router';

import {provideSilentReauth} from '@core/auth';
import {provideI18n} from '@core/i18n';
import {authInterceptor, errorInterceptor} from '@core/interceptors';
import {provideUi} from '@core/theme';

import {routes} from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withFetch(), withInterceptors([errorInterceptor, authInterceptor])),
    provideUi(),
    provideI18n(),
    provideSilentReauth(),
  ],
};
